msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-22\n"
"Language: en\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: Lingui\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/routes/Users.tsx:80
msgid " (you)"
msgstr " (you)"

#: src/routes/Plans.tsx:331
msgid "— off —"
msgstr "— off —"

#: src/routes/Plans.tsx:310
msgid "— same as the chat model —"
msgstr "— same as the chat model —"

#: src/routes/Plans.tsx:296
msgid "— select —"
msgstr "— select —"

#: src/components/FeatureSelector.tsx:84
msgid ".write and .post still require the write-mode checkbox on the remote config"
msgstr ".write and .post still require the write-mode checkbox on the remote config"

#. placeholder {0}: features.size
#. placeholder {1}: ALL_FEATURE_IDS.length
#: src/components/FeatureSelector.tsx:58
msgid "({0} of {1} active)"
msgstr "({0} of {1} active)"

#: src/routes/LicenseSwaps.tsx:92
#: src/routes/LicenseSwaps.tsx:106
msgid "(any)"
msgstr "(any)"

#: src/routes/CustomerDetail.tsx:1215
#: src/routes/CustomerDetail.tsx:1295
msgid "(gate for every <0>.write</0> and <1>.post</1> feature — required in addition to the checkboxes above)"
msgstr "(gate for every <0>.write</0> and <1>.post</1> feature — required in addition to the checkboxes above)"

#: src/routes/CustomerDetail.tsx:684
msgid "(no label)"
msgstr "(no label)"

#: src/routes/Monitoring.tsx:225
msgid "(no message)"
msgstr "(no message)"

#: src/routes/ConversationDetail.tsx:120
#: src/routes/Conversations.tsx:503
msgid "(untitled)"
msgstr "(untitled)"

#. placeholder {0}: h.month
#. placeholder {1}: h.costUsd.toFixed(2)
#. placeholder {2}: h.turnCount
#: src/routes/CustomerDetail.tsx:1481
msgid "{0} — ${1} · {2} turns"
msgstr "{0} — ${1} · {2} turns"

#. placeholder {0}: h.month
#. placeholder {1}: h.costUsd.toFixed(2)
#. placeholder {2}: credited.toFixed(2)
#. placeholder {3}: h.turnCount
#: src/routes/CustomerDetail.tsx:1480
msgid "{0} — ${1} billed · ${2} credited · {3} turns"
msgstr "{0} — ${1} billed · ${2} credited · {3} turns"

#. placeholder {0}: p.label
#: src/routes/LlmModels.tsx:464
msgid "{0} (archived)"
msgstr "{0} (archived)"

#. placeholder {0}: rate(request.rates.inputPerMtok)
#: src/components/RequestPricing.tsx:19
msgid "{0} (input-rate fallback)"
msgstr "{0} (input-rate fallback)"

#. placeholder {0}: u.licenses.filter(l => l.exhausted).length
#. placeholder {1}: u.licenses.length
#: src/routes/Customers.tsx:71
msgid "{0} exhausted licences / {1}"
msgstr "{0} exhausted licences / {1}"

#. placeholder {0}: formatCost(costUsd, i18n.locale)
#: src/routes/ConversationDetail.tsx:367
msgid "{0} stops counting against the customer's plan budget and licence cap, and the conversation disappears from the customer's app. You can undo this later."
msgstr "{0} stops counting against the customer's plan budget and licence cap, and the conversation disappears from the customer's app. You can undo this later."

#. placeholder {0}: failedTurns.length
#: src/routes/ConversationDetail.tsx:159
msgid "{0} turn(s) did not complete"
msgstr "{0} turn(s) did not complete"

#. placeholder {0}: pctOfBudget.toFixed(0)
#: src/routes/Usage.tsx:333
msgid "{0}% of budget"
msgstr "{0}% of budget"

#. placeholder {0}: pctOfBudget.toFixed(0)
#. placeholder {1}: pctOfCap.toFixed(0)
#: src/routes/Usage.tsx:329
msgid "{0}% of budget · {1}% of hard cap"
msgstr "{0}% of budget · {1}% of hard cap"

#. placeholder {0}: p.retentionDays
#: src/routes/Plans.tsx:100
msgid "{0}d"
msgstr "{0}d"

#. placeholder {0}: Math.floor(seconds / 86400)
#: src/routes/Monitoring.tsx:312
msgid "{0}d ago"
msgstr "{0}d ago"

#. placeholder {0}: Math.floor(seconds / 3600)
#: src/routes/Monitoring.tsx:311
msgid "{0}h ago"
msgstr "{0}h ago"

#. placeholder {0}: Math.floor(seconds / 60)
#: src/routes/Monitoring.tsx:310
msgid "{0}m ago"
msgstr "{0}m ago"

#: src/routes/Conversations.tsx:214
msgid "{failedTurnCount} failed turn(s), without an error code"
msgstr "{failedTurnCount} failed turn(s), without an error code"

#. placeholder {0}: turnErrorCodes.join(", ")
#: src/routes/Conversations.tsx:213
msgid "{failedTurnCount} failed turn(s): {0}"
msgstr "{failedTurnCount} failed turn(s): {0}"

#: src/routes/Monitoring.tsx:309
msgid "{seconds}s ago"
msgstr "{seconds}s ago"

#. placeholder {0}: toolNames.join(", ")
#: src/routes/Conversations.tsx:210
msgid "{toolFailureCount} failed call(s): {0}"
msgstr "{toolFailureCount} failed call(s): {0}"

#. placeholder {0}: offset + 1
#. placeholder {1}: Math.min(offset + entries.length, total)
#: src/routes/AuditLog.tsx:94
#: src/routes/LicenseSwaps.tsx:122
msgid "{total} total entries — showing {0}–{1}"
msgstr "{total} total entries — showing {0}–{1}"

#: src/routes/Customers.tsx:298
msgid "/mo"
msgstr "/mo"

#: src/routes/ConversationDetail.tsx:118
msgid "← All conversations"
msgstr "← All conversations"

#: src/routes/NewConfig.tsx:300
#: src/routes/SealSecrets.tsx:242
msgid "← Back to customer"
msgstr "← Back to customer"

#: src/routes/AuditLog.tsx:158
#: src/routes/LicenseSwaps.tsx:190
msgid "← Newer"
msgstr "← Newer"

#: src/routes/CustomerDetail.tsx:1453
msgid "12-month history"
msgstr "12-month history"

#: src/routes/ConversationDetail.tsx:344
msgid "A note is required when the reason is \"Other\"."
msgstr "A note is required when the reason is \"Other\"."

#: src/routes/Releases.tsx:324
msgid "ab12…64 hex"
msgstr "ab12…64 hex"

#: src/routes/NewConfig.tsx:360
msgid "Accounting — Montreal"
msgstr "Accounting — Montreal"

#: src/features-catalog.ts:40
msgid "Accounts Payable"
msgstr "Accounts Payable"

#: src/features-catalog.ts:48
msgid "Accounts Receivable"
msgstr "Accounts Receivable"

#: src/routes/AuditLog.tsx:104
#: src/routes/LicenseSwaps.tsx:98
#: src/routes/LicenseSwaps.tsx:132
msgid "Action"
msgstr "Action"

#: src/routes/CustomerDetail.tsx:524
msgid "Activation"
msgstr "Activation"

#: src/routes/CustomerDetail.tsx:825
#: src/routes/Users.tsx:88
msgid "active"
msgstr "active"

#: src/routes/Releases.tsx:180
msgid "Active releases"
msgstr "Active releases"

#: src/routes/NewConfig.tsx:561
msgid "Add a company"
msgstr "Add a company"

#: src/routes/LlmModels.tsx:130
msgid "Add price"
msgstr "Add price"

#: src/routes/AuditLog.tsx:102
msgid "Admin"
msgstr "Admin"

#: src/routes/AuditLog.tsx:59
msgid "Admin audit log"
msgstr "Admin audit log"

#: src/routes/SystemPrompts.tsx:120
#: src/routes/SystemPrompts.tsx:289
msgid "Admin label"
msgstr "Admin label"

#: src/routes/SystemPrompts.tsx:254
msgid "Admin label is required"
msgstr "Admin label is required"

#: src/features-catalog.ts:113
msgid "Administrative Services"
msgstr "Administrative Services"

#: src/routes/CustomerDetail.tsx:557
msgid "Administrator authorization required"
msgstr "Administrator authorization required"

#: src/routes/Users.tsx:59
msgid "Administrators & resellers"
msgstr "Administrators & resellers"

#: src/features-catalog.ts:33
msgid "Advanced Windows-isolated document scripts (approval required per run)"
msgstr "Advanced Windows-isolated document scripts (approval required per run)"

#: src/routes/Errors.tsx:469
#: src/routes/Monitoring.tsx:144
msgid "Agent"
msgstr "Agent"

#. placeholder {0}: m.agentVersion
#: src/routes/CustomerDetail.tsx:673
msgid "agent {0}"
msgstr "agent {0}"

#: src/routes/Monitoring.tsx:126
msgid "all"
msgstr "all"

#: src/routes/Conversations.tsx:65
#: src/routes/Conversations.tsx:76
#: src/routes/Customers.tsx:237
msgid "All"
msgstr "All"

#: src/routes/Conversations.tsx:311
#: src/routes/Errors.tsx:276
msgid "All customers"
msgstr "All customers"

#: src/routes/Conversations.tsx:329
#: src/routes/Errors.tsx:294
msgid "All machines"
msgstr "All machines"

#: src/routes/LlmModels.tsx:161
#: src/routes/LlmModels.tsx:602
msgid "All rates are USD per million tokens. Empty cache rates use the input rate of the selected tier; zero means free."
msgstr "All rates are USD per million tokens. Empty cache rates use the input rate of the selected tier; zero means free."

#: src/routes/Conversations.tsx:407
msgid "All reasons"
msgstr "All reasons"

#: src/routes/CustomerDetail.tsx:1215
#: src/routes/CustomerDetail.tsx:1295
msgid "Allow write mode"
msgstr "Allow write mode"

#: src/routes/CustomerDetail.tsx:1348
msgid "Allowances belong to each licence and cannot be shared."
msgstr "Allowances belong to each licence and cannot be shared."

#: src/routes/SealSecrets.tsx:298
msgid "already sealed"
msgstr "already sealed"

#: src/routes/CustomerDetail.tsx:1398
msgid "Amount"
msgstr "Amount"

#: src/routes/NewConfig.tsx:516
msgid "API version"
msgstr "API version"

#: src/components/RequestPricing.tsx:30
msgid "Applied tier"
msgstr "Applied tier"

#: src/routes/CustomerDetail.tsx:1106
msgid "Applies at the next agent config poll — the mcp-server restarts with the new schema bundle."
msgstr "Applies at the next agent config poll — the mcp-server restarts with the new schema bundle."

#: src/routes/NewConfig.tsx:337
msgid "Applies to conversation source files and generated documents on each customer machine."
msgstr "Applies to conversation source files and generated documents on each customer machine."

#: src/routes/LlmModels.tsx:610
msgid "Applies to the whole request only when total input, including cache reads and writes, strictly exceeds the threshold."
msgstr "Applies to the whole request only when total input, including cache reads and writes, strictly exceeds the threshold."

#. placeholder {0}: e.status
#: src/routes/Monitoring.tsx:213
msgid "apply {0}"
msgstr "apply {0}"

#: src/routes/Monitoring.tsx:95
msgid "Apply failed (24h)"
msgstr "Apply failed (24h)"

#: src/routes/Monitoring.tsx:90
msgid "Apply ok (24h)"
msgstr "Apply ok (24h)"

#: src/routes/LicenseSwaps.tsx:93
msgid "approved"
msgstr "approved"

#: src/routes/Releases.tsx:130
#: src/routes/SystemPrompts.tsx:99
msgid "Archive"
msgstr "Archive"

#. placeholder {0}: p.label
#: src/routes/SystemPrompts.tsx:45
msgid "Archive prompt \"{0}\"? Any active model still using it must be reassigned first."
msgstr "Archive prompt \"{0}\"? Any active model still using it must be reassigned first."

#. placeholder {0}: v.version
#. placeholder {1}: v.channel
#: src/routes/Releases.tsx:54
msgid "Archive version {0} on {1}? Agents will stop seeing it as the latest release."
msgstr "Archive version {0} on {1}? Agents will stop seeing it as the latest release."

#: src/routes/ConversationDetail.tsx:131
#: src/routes/Conversations.tsx:505
msgid "archived"
msgstr "archived"

#: src/routes/Conversations.tsx:420
msgid "Archived"
msgstr "Archived"

#: src/routes/SystemPrompts.tsx:165
msgid "Archived prompts"
msgstr "Archived prompts"

#: src/routes/Releases.tsx:186
msgid "Archived releases"
msgstr "Archived releases"

#: src/components/Layout.tsx:185
msgid "Audit log"
msgstr "Audit log"

#: src/routes/CustomerDetail.tsx:629
#: src/routes/Usage.tsx:144
msgid "Available"
msgstr "Available"

#: src/routes/CustomerDetail.tsx:557
msgid "Awaiting activation"
msgstr "Awaiting activation"

#: src/routes/CustomerDetail.tsx:557
msgid "Awaiting replacement"
msgstr "Awaiting replacement"

#: src/routes/ConversationDetail.tsx:90
msgid "Back to list"
msgstr "Back to list"

#: src/features-catalog.ts:92
msgid "Bank Services"
msgstr "Bank Services"

#: src/routes/NewConfig.tsx:487
msgid "Base URL"
msgstr "Base URL"

#: src/routes/CustomerDetail.tsx:1460
msgid "Billed"
msgstr "Billed"

#: src/components/Layout.tsx:168
msgid "Billing"
msgstr "Billing"

#: src/routes/Usage.tsx:110
msgid "Budget"
msgstr "Budget"

#: src/routes/Plans.tsx:140
msgid "Budget / month"
msgstr "Budget / month"

#: src/routes/CustomerDetail.tsx:1352
#~ msgid "By licence"
#~ msgstr "By licence"

#: src/routes/CustomerDetail.tsx:1406
#~ msgid "By model"
#~ msgstr "By model"

#: src/components/RequestPricing.tsx:43
#: src/routes/ConversationDetail.tsx:261
#: src/routes/ConversationDetail.tsx:440
msgid "Cache write"
msgstr "Cache write"

#: src/routes/LlmModels.tsx:578
msgid "Cache write $/1M tokens (optional — set for models with a cache-write premium; leave empty to bill at the input rate)"
msgstr "Cache write $/1M tokens (optional — set for models with a cache-write premium; leave empty to bill at the input rate)"

#: src/routes/LlmModels.tsx:627
msgid "Cache write $/1M tokens (optional)"
msgstr "Cache write $/1M tokens (optional)"

#: src/routes/LlmModels.tsx:169
msgid "Cache write $/Mtok"
msgstr "Cache write $/Mtok"

#: src/routes/ConversationDetail.tsx:441
msgid "cache-w"
msgstr "cache-w"

#: src/routes/Conversations.tsx:483
msgid "Cache-w"
msgstr "Cache-w"

#: src/routes/ConversationDetail.tsx:436
msgid "cached"
msgstr "cached"

#: src/routes/Conversations.tsx:482
msgid "Cached"
msgstr "Cached"

#: src/routes/LlmModels.tsx:566
#: src/routes/LlmModels.tsx:622
msgid "Cached input $/1M tokens (optional)"
msgstr "Cached input $/1M tokens (optional)"

#: src/routes/LlmModels.tsx:168
msgid "Cached input $/Mtok"
msgstr "Cached input $/Mtok"

#: src/components/RequestPricing.tsx:42
#: src/routes/ConversationDetail.tsx:255
#: src/routes/ConversationDetail.tsx:435
msgid "Cached read"
msgstr "Cached read"

#: src/routes/Usage.tsx:227
msgid "Calls"
msgstr "Calls"

#: src/features-catalog.ts:106
msgid "Canadian Payroll"
msgstr "Canadian Payroll"

#: src/components/ChangeLicensePlanDialog.tsx:79
#: src/components/TransferLicenseDialog.tsx:45
#: src/routes/ConversationDetail.tsx:400
#: src/routes/CustomerDetail.tsx:1060
#: src/routes/CustomerDetail.tsx:1129
#: src/routes/CustomerDetail.tsx:1221
#: src/routes/CustomerDetail.tsx:1301
#: src/routes/Customers.tsx:409
#: src/routes/LlmModels.tsx:476
#: src/routes/LlmModels.tsx:641
#: src/routes/NewConfig.tsx:585
#: src/routes/Plans.tsx:399
#: src/routes/Releases.tsx:353
#: src/routes/SystemPrompts.tsx:376
#: src/routes/Users.tsx:208
msgid "Cancel"
msgstr "Cancel"

#: src/features-catalog.ts:140
msgid "Cdn PR Tax Update"
msgstr "Cdn PR Tax Update"

#: src/components/ChangeLicensePlanDialog.tsx:50
#: src/routes/CustomerDetail.tsx:549
msgid "Change licence plan"
msgstr "Change licence plan"

#: src/routes/CustomerDetail.tsx:431
#: src/routes/CustomerDetail.tsx:1104
msgid "Change Sage version"
msgstr "Change Sage version"

#: src/routes/Releases.tsx:145
#: src/routes/Releases.tsx:298
msgid "Channel"
msgstr "Channel"

#: src/routes/Conversations.tsx:69
msgid "Clean"
msgstr "Clean"

#: src/components/FeatureSelector.tsx:100
msgid "Clear"
msgstr "Clear"

#: src/routes/Conversations.tsx:248
#: src/routes/Errors.tsx:172
msgid "Clear all filters"
msgstr "Clear all filters"

#: src/routes/Conversations.tsx:465
#: src/routes/Errors.tsx:373
msgid "Clear filters"
msgstr "Clear filters"

#: src/routes/Conversations.tsx:275
#: src/routes/Errors.tsx:199
msgid "Clear search"
msgstr "Clear search"

#: src/components/Layout.tsx:163
msgid "Clients"
msgstr "Clients"

#: src/routes/CustomerDetail.tsx:852
#: src/routes/CustomerDetail.tsx:976
msgid "Close"
msgstr "Close"

#: src/routes/Errors.tsx:457
#: src/routes/Plans.tsx:137
#: src/routes/Plans.tsx:280
msgid "Code"
msgstr "Code"

#: src/routes/ConversationDetail.tsx:555
msgid "Collapse"
msgstr "Collapse"

#: src/credit-reason-labels.ts:18
msgid "Commercial gesture"
msgstr "Commercial gesture"

#: src/features-catalog.ts:99
msgid "Common Services"
msgstr "Common Services"

#: src/routes/SealSecrets.tsx:266
msgid "Companies this machine may query"
msgstr "Companies this machine may query"

#: src/routes/CustomerDetail.tsx:789
#: src/routes/Customers.tsx:399
msgid "Company"
msgstr "Company"

#: src/routes/NewConfig.tsx:509
msgid "Company (Sage code)"
msgstr "Company (Sage code)"

#: src/routes/NewConfig.tsx:370
msgid "Company id (local slug)"
msgstr "Company id (local slug)"

#: src/routes/NewConfig.tsx:389
msgid "Company id (local slug):"
msgstr "Company id (local slug):"

#: src/routes/CustomerDetail.tsx:661
#: src/routes/Monitoring.tsx:147
msgid "Config"
msgstr "Config"

#: src/routes/CustomerDetail.tsx:660
msgid "Configurations"
msgstr "Configurations"

#: src/components/ChangeLicensePlanDialog.tsx:80
msgid "Confirm plan change"
msgstr "Confirm plan change"

#: src/components/TransferLicenseDialog.tsx:47
msgid "Confirm transfer"
msgstr "Confirm transfer"

#: src/routes/Customers.tsx:260
msgid "Contact"
msgstr "Contact"

#: src/routes/Customers.tsx:386
msgid "Contact email"
msgstr "Contact email"

#: src/routes/Customers.tsx:395
msgid "Contact name"
msgstr "Contact name"

#: src/routes/SystemPrompts.tsx:299
msgid "Content"
msgstr "Content"

#: src/routes/SystemPrompts.tsx:258
msgid "Content is required"
msgstr "Content is required"

#: src/routes/Errors.tsx:482
#: src/routes/LlmModels.tsx:207
msgid "Context"
msgstr "Context"

#: src/routes/LlmModels.tsx:413
msgid "Context window (tokens)"
msgstr "Context window (tokens)"

#: src/routes/ConversationDetail.tsx:77
#: src/routes/ConversationDetail.tsx:88
#: src/routes/CustomerDetail.tsx:1394
msgid "Conversation"
msgstr "Conversation"

#: src/routes/Conversations.tsx:443
msgid "conversation(s)"
msgstr "conversation(s)"

#: src/components/Layout.tsx:182
#: src/routes/Conversations.tsx:242
msgid "Conversations"
msgstr "Conversations"

#: src/routes/NewConfig.tsx:550
msgid "Conversations that use this company become read-only. The row stays in the config so it can be reactivated later; sealed passwords are kept."
msgstr "Conversations that use this company become read-only. The row stays in the config so it can be reactivated later; sealed passwords are kept."

#: src/components/CopyButton.tsx:77
msgid "Copied"
msgstr "Copied"

#: src/components/CopyButton.tsx:72
msgid "Copy"
msgstr "Copy"

#: src/routes/CustomerDetail.tsx:542
#: src/routes/CustomerDetail.tsx:851
msgid "Copy licence key"
msgstr "Copy licence key"

#: src/routes/Conversations.tsx:485
#: src/routes/CustomerDetail.tsx:527
#: src/routes/Usage.tsx:230
msgid "Cost"
msgstr "Cost"

#: src/routes/Customers.tsx:265
msgid "Cost (mo)"
msgstr "Cost (mo)"

#: src/routes/SystemPrompts.tsx:333
msgid "Cost per call"
msgstr "Cost per call"

#: src/auth.tsx:264
msgid "Could not reach the cloud API. Check VITE_CLOUD_API_URL or that the service is running."
msgstr "Could not reach the cloud API. Check VITE_CLOUD_API_URL or that the service is running."

#: src/routes/Customers.tsx:412
#: src/routes/Users.tsx:211
msgid "Create"
msgstr "Create"

#: src/routes/ConversationDetail.tsx:187
#: src/routes/CustomerDetail.tsx:1543
#: src/routes/Customers.tsx:272
msgid "Created"
msgstr "Created"

#: src/routes/CustomerDetail.tsx:1224
#: src/routes/Customers.tsx:412
#: src/routes/Users.tsx:211
msgid "Creating…"
msgstr "Creating…"

#: src/routes/ConversationDetail.tsx:140
#: src/routes/ConversationDetail.tsx:403
msgid "Credit"
msgstr "Credit"

#: src/routes/ConversationDetail.tsx:365
msgid "Credit this conversation"
msgstr "Credit this conversation"

#: src/routes/ConversationDetail.tsx:132
msgid "credited"
msgstr "credited"

#: src/routes/CustomerDetail.tsx:631
#: src/routes/CustomerDetail.tsx:1397
#: src/routes/CustomerDetail.tsx:1464
msgid "Credited"
msgstr "Credited"

#: src/routes/Customers.tsx:269
msgid "Credited (mo)"
msgstr "Credited (mo)"

#: src/routes/CustomerDetail.tsx:1396
msgid "Credited by"
msgstr "Credited by"

#. placeholder {0}: detail.credit.creditedByEmail ?? "—"
#. placeholder {1}: new Date(detail.credit.createdAt).toLocaleString(i18n.locale)
#. placeholder {2}: i18n._(CREDIT_REASON_LABELS[detail.credit.reason])
#: src/routes/ConversationDetail.tsx:202
msgid "Credited by {0} on {1} — {2}"
msgstr "Credited by {0} on {1} — {2}"

#: src/routes/CustomerDetail.tsx:1384
msgid "Credited conversations"
msgstr "Credited conversations"

#: src/routes/CustomerDetail.tsx:1373
msgid "Credited this month"
msgstr "Credited this month"

#: src/routes/ConversationDetail.tsx:403
msgid "Crediting…"
msgstr "Crediting…"

#: src/features-catalog.ts:29
msgid "Cross-module SQL joins (sage300_db_cross_query)"
msgstr "Cross-module SQL joins (sage300_db_cross_query)"

#: src/routes/CustomerDetail.tsx:525
msgid "Current machine"
msgstr "Current machine"

#: src/components/ChangeLicensePlanDialog.tsx:65
msgid "Current retention: {currentDays} days."
msgstr "Current retention: {currentDays} days."

#: src/routes/ConversationDetail.tsx:178
#: src/routes/Conversations.tsx:300
#: src/routes/Conversations.tsx:476
#: src/routes/Errors.tsx:265
#: src/routes/Errors.tsx:386
#: src/routes/LicenseSwaps.tsx:130
#: src/routes/Monitoring.tsx:141
#: src/routes/Monitoring.tsx:202
#: src/routes/Usage.tsx:99
msgid "Customer"
msgstr "Customer"

#: src/routes/CustomerDetail.tsx:477
msgid "Customer deactivated"
msgstr "Customer deactivated"

#: src/routes/LicenseSwaps.tsx:62
msgid "Customer ID"
msgstr "Customer ID"

#: src/routes/CustomerDetail.tsx:386
msgid "Customer not found."
msgstr "Customer not found."

#: src/routes/Errors.tsx:322
msgid "Customer: {selectedCustomerName}"
msgstr "Customer: {selectedCustomerName}"

#: src/routes/Customers.tsx:294
msgid "customers"
msgstr "customers"

#: src/components/Layout.tsx:164
#: src/routes/Customers.tsx:228
msgid "Customers"
msgstr "Customers"

#: src/feedback-labels.ts:16
msgid "Data does not match Sage"
msgstr "Data does not match Sage"

#: src/routes/NewConfig.tsx:438
msgid "Database"
msgstr "Database"

#: src/routes/NewConfig.tsx:445
msgid "DB user"
msgstr "DB user"

#: src/routes/LlmModels.tsx:137
#: src/routes/Plans.tsx:116
msgid "Deactivate"
msgstr "Deactivate"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:317
msgid "Deactivate {0}? Every licence attached to this customer will stop working at the next agent request. You can add a short note (optional):"
msgstr "Deactivate {0}? Every licence attached to this customer will stop working at the next agent request. You can add a short note (optional):"

#: src/routes/CustomerDetail.tsx:450
msgid "Deactivate customer"
msgstr "Deactivate customer"

#. placeholder {0}: m.displayName
#: src/routes/LlmModels.tsx:65
msgid "Deactivate model \"{0}\"? Active plans referencing it must be reassigned first."
msgstr "Deactivate model \"{0}\"? Active plans referencing it must be reassigned first."

#. placeholder {0}: p.code
#: src/routes/Plans.tsx:43
msgid "Deactivate plan \"{0}\"? Customers attached to it must be reassigned first."
msgstr "Deactivate plan \"{0}\"? Customers attached to it must be reassigned first."

#: src/routes/NewConfig.tsx:552
msgid "Deactivate this company"
msgstr "Deactivate this company"

#: src/routes/Customers.tsx:30
msgid "deactivated"
msgstr "deactivated"

#: src/routes/CustomerDetail.tsx:809
msgid "default"
msgstr "default"

#: src/routes/NewConfig.tsx:426
msgid "Default company for this customer"
msgstr "Default company for this customer"

#: src/routes/CustomerDetail.tsx:613
#: src/routes/CustomerDetail.tsx:738
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: l.licenseKey
#: src/routes/CustomerDetail.tsx:281
msgid "Delete licence {0}? This cannot be undone. Any machine still bound to it must be deleted first."
msgstr "Delete licence {0}? This cannot be undone. Any machine still bound to it must be deleted first."

#: src/routes/CustomerDetail.tsx:299
msgid "Delete this machine? This wipes its heartbeats, config state and encrypted secrets. This cannot be undone."
msgstr "Delete this machine? This wipes its heartbeats, config state and encrypted secrets. This cannot be undone."

#: src/routes/CustomerDetail.tsx:849
msgid "Deliver this rotated key securely to the replacement operator. Use Change license key on the desktop to validate and protect the key, then configure Sage access. Old-machine files remain on the old machine."
msgstr "Deliver this rotated key securely to the replacement operator. Use Change license key on the desktop to validate and protect the key, then configure Sage access. Old-machine files remain on the old machine."

#: src/credit-reason-labels.ts:17
msgid "Demo"
msgstr "Demo"

#: src/routes/Monitoring.tsx:204
msgid "Detail"
msgstr "Detail"

#: src/routes/AuditLog.tsx:128
msgid "Diff"
msgstr "Diff"

#: src/routes/Customers.tsx:53
msgid "Direct"
msgstr "Direct"

#: src/routes/CustomerDetail.tsx:419
#: src/routes/Customers.tsx:238
msgid "Direct (Jalfa)"
msgstr "Direct (Jalfa)"

#: src/routes/Users.tsx:102
msgid "Disable"
msgstr "Disable"

#: src/routes/CustomerDetail.tsx:823
#: src/routes/SealSecrets.tsx:295
#: src/routes/Users.tsx:88
msgid "disabled"
msgstr "disabled"

#: src/routes/NewConfig.tsx:350
msgid "Disabled"
msgstr "Disabled"

#: src/routes/NewConfig.tsx:535
msgid "Discard this new company"
msgstr "Discard this new company"

#: src/features-catalog.ts:25
msgid "Discovery tools (search_entities, describe_entity, resolve_question)"
msgstr "Discovery tools (search_entities, describe_entity, resolve_question)"

#: src/routes/LlmModels.tsx:206
#: src/routes/LlmModels.tsx:405
#: src/routes/NewConfig.tsx:356
msgid "Display name"
msgstr "Display name"

#: src/routes/NewConfig.tsx:323
msgid "Document storage"
msgstr "Document storage"

#: src/routes/SealSecrets.tsx:344
msgid "Done"
msgstr "Done"

#: src/routes/Releases.tsx:151
#: src/routes/Releases.tsx:310
msgid "Download URL"
msgstr "Download URL"

#: src/credit-reason-labels.ts:19
msgid "Duplicate turn"
msgstr "Duplicate turn"

#: src/routes/CustomerDetail.tsx:1205
#: src/routes/CustomerDetail.tsx:1285
msgid "e.g. HQ production, staging, trial 2026-Q1"
msgstr "e.g. HQ production, staging, trial 2026-Q1"

#: src/routes/CustomerDetail.tsx:580
#: src/routes/CustomerDetail.tsx:589
#: src/routes/CustomerDetail.tsx:768
#: src/routes/LlmModels.tsx:117
#: src/routes/LlmModels.tsx:125
#: src/routes/NewConfig.tsx:395
#: src/routes/Plans.tsx:103
#: src/routes/Plans.tsx:108
#: src/routes/Releases.tsx:109
#: src/routes/Releases.tsx:114
#: src/routes/SystemPrompts.tsx:86
#: src/routes/SystemPrompts.tsx:91
msgid "Edit"
msgstr "Edit"

#. placeholder {0}: model!.displayName
#. placeholder {0}: prompt!.label
#: src/routes/LlmModels.tsx:381
#: src/routes/SystemPrompts.tsx:286
msgid "Edit {0}"
msgstr "Edit {0}"

#: src/routes/CustomerDetail.tsx:1272
msgid "Edit licence"
msgstr "Edit licence"

#: src/routes/Plans.tsx:277
msgid "Edit plan"
msgstr "Edit plan"

#: src/routes/Releases.tsx:278
msgid "Edit release"
msgstr "Edit release"

#: src/routes/NewConfig.tsx:307
msgid "Editing the live config (revision {prefilledFrom}). Saving fans the change out to every connected machine of this customer; sealed passwords stay put."
msgstr "Editing the live config (revision {prefilledFrom}). Saving fans the change out to every connected machine of this customer; sealed passwords stay put."

#: src/routes/LlmModels.tsx:165
msgid "Effective at"
msgstr "Effective at"

#: src/routes/LlmModels.tsx:547
msgid "Effective at (ISO 8601)"
msgstr "Effective at (ISO 8601)"

#: src/routes/Login.tsx:21
#: src/routes/Users.tsx:69
#: src/routes/Users.tsx:178
msgid "Email"
msgstr "Email"

#: src/auth.tsx:251
msgid "Email and password are required"
msgstr "Email and password are required"

#: src/components/Layout.tsx:243
msgid "emergency root"
msgstr "emergency root"

#: src/routes/LlmModels.tsx:605
msgid "Enable long-context pricing"
msgstr "Enable long-context pricing"

#: src/routes/NewConfig.tsx:469
msgid "Encrypt TLS (recommended — keep on)"
msgstr "Encrypt TLS (recommended — keep on)"

#. placeholder {0}: incomplete.map(companyDisplayName).join(", ")
#: src/routes/SealSecrets.tsx:158
msgid "Enter a password for: {0}"
msgstr "Enter a password for: {0}"

#: src/routes/AuditLog.tsx:62
#: src/routes/AuditLog.tsx:103
msgid "Entity"
msgstr "Entity"

#: src/routes/AuditLog.tsx:73
msgid "Entity ID"
msgstr "Entity ID"

#: src/routes/Monitoring.tsx:297
msgid "error"
msgstr "error"

#: src/routes/Errors.tsx:313
msgid "error(s)"
msgstr "error(s)"

#: src/components/Layout.tsx:184
#: src/routes/Errors.tsx:166
msgid "Errors"
msgstr "Errors"

#: src/routes/Monitoring.tsx:100
msgid "Errors (24h)"
msgstr "Errors (24h)"

#: src/routes/CustomerDetail.tsx:1542
msgid "Estimated cost"
msgstr "Estimated cost"

#: src/routes/SystemPrompts.tsx:310
msgid "Estimated cost per model"
msgstr "Estimated cost per model"

#: src/routes/SystemPrompts.tsx:367
msgid "Estimating…"
msgstr "Estimating…"

#: src/routes/CustomerDetail.tsx:499
msgid "Every licence attached to this customer is refused at the cloud auth layer. Individual licence/machine statuses are unchanged."
msgstr "Every licence attached to this customer is refused at the cloud auth layer. Individual licence/machine statuses are unchanged."

#: src/components/FeatureSelector.tsx:93
msgid "Everything"
msgstr "Everything"

#: src/routes/CustomerDetail.tsx:629
#: src/routes/Usage.tsx:144
msgid "Exhausted"
msgstr "Exhausted"

#: src/routes/ConversationDetail.tsx:555
msgid "Expand"
msgstr "Expand"

#: src/components/ChangeLicensePlanDialog.tsx:76
msgid "Extending retention cannot restore history that has already been deleted."
msgstr "Extending retention cannot restore history that has already been deleted."

#: src/routes/LlmModels.tsx:440
msgid "Extra high"
msgstr "Extra high"

#: src/routes/Monitoring.tsx:176
msgid "failed"
msgstr "failed"

#: src/routes/Users.tsx:50
msgid "Failed: {msg}"
msgstr "Failed: {msg}"

#: src/routes/Conversations.tsx:339
msgid "Failures"
msgstr "Failures"

#: src/components/FeatureSelector.tsx:58
#: src/routes/CustomerDetail.tsx:528
msgid "Features"
msgstr "Features"

#. placeholder {0}: features.length
#: src/routes/CustomerDetail.tsx:950
msgid "Features ({0} active)"
msgstr "Features ({0} active)"

#: src/routes/NewConfig.tsx:573
msgid "Features and write mode are set on the licence, not on the remote config. Edit the licence from the customer page to change what the MCP is allowed to touch on this customer's machines."
msgstr "Features and write mode are set on the licence, not on the remote config. Edit the licence from the customer page to change what the MCP is allowed to touch on this customer's machines."

#: src/routes/Conversations.tsx:478
msgid "Feedback"
msgstr "Feedback"

#: src/routes/Conversations.tsx:77
msgid "Flagged"
msgstr "Flagged"

#: src/routes/LicenseSwaps.tsx:134
msgid "From → To"
msgstr "From → To"

#: src/routes/SystemPrompts.tsx:304
msgid "Full system prompt text — no length limit."
msgstr "Full system prompt text — no length limit."

#: src/features-catalog.ts:118
msgid "G/L Subledger Services"
msgstr "G/L Subledger Services"

#: src/features-catalog.ts:56
msgid "General Ledger"
msgstr "General Ledger"

#: src/routes/ConversationDetail.tsx:150
msgid "Guidance diagnostics"
msgstr "Guidance diagnostics"

#: src/routes/Plans.tsx:350
msgid "Guidance mode"
msgstr "Guidance mode"

#: src/routes/CustomerDetail.tsx:626
msgid "Hard cap slack"
msgstr "Hard cap slack"

#: src/routes/Monitoring.tsx:213
msgid "heartbeat"
msgstr "heartbeat"

#: src/routes/Usage.tsx:109
msgid "Held"
msgstr "Held"

#: src/routes/CustomerDetail.tsx:628
#: src/routes/CustomerDetail.tsx:1364
#: src/routes/Usage.tsx:81
msgid "Held reservations"
msgstr "Held reservations"

#: src/routes/CustomerDetail.tsx:1536
msgid "Held reservations (in flight)"
msgstr "Held reservations (in flight)"

#: src/routes/ConversationDetail.tsx:475
msgid "helpful"
msgstr "helpful"

#: src/routes/LlmModels.tsx:122
msgid "Hide"
msgstr "Hide"

#: src/routes/AuditLog.tsx:128
msgid "Hide diff"
msgstr "Hide diff"

#: src/routes/LlmModels.tsx:439
msgid "High"
msgstr "High"

#: src/components/TransferLicenseDialog.tsx:41
msgid "I authorize this replacement and revocation of the previous machine."
msgstr "I authorize this replacement and revocation of the previous machine."

#: src/components/ChangeLicensePlanDialog.tsx:72
msgid "I understand and confirm the shorter retention window."
msgstr "I understand and confirm the shorter retention window."

#: src/routes/CustomerDetail.tsx:790
msgid "Id"
msgstr "Id"

#: src/routes/AuditLog.tsx:105
msgid "ID"
msgstr "ID"

#: src/routes/ConversationDetail.tsx:432
msgid "in"
msgstr "in"

#: src/routes/LlmModels.tsx:231
msgid "Inactive models"
msgstr "Inactive models"

#: src/routes/Plans.tsx:164
msgid "Inactive plans"
msgstr "Inactive plans"

#: src/routes/Conversations.tsx:429
msgid "Include archived"
msgstr "Include archived"

#: src/feedback-labels.ts:15
msgid "Incomplete answer"
msgstr "Incomplete answer"

#: src/routes/Conversations.tsx:481
#: src/routes/Usage.tsx:228
msgid "Input"
msgstr "Input"

#: src/routes/LlmModels.tsx:555
#: src/routes/LlmModels.tsx:617
msgid "Input $/1M tokens"
msgstr "Input $/1M tokens"

#: src/routes/LlmModels.tsx:167
#: src/routes/SystemPrompts.tsx:330
msgid "Input $/Mtok"
msgstr "Input $/Mtok"

#: src/components/RequestPricing.tsx:32
msgid "Input threshold"
msgstr "Input threshold"

#: src/routes/LlmModels.tsx:612
msgid "Input token threshold"
msgstr "Input token threshold"

#: src/components/RequestPricing.tsx:41
#: src/routes/ConversationDetail.tsx:249
#: src/routes/ConversationDetail.tsx:431
#: src/routes/CustomerDetail.tsx:633
#: src/routes/CustomerDetail.tsx:1352
#: src/routes/Usage.tsx:85
msgid "Input tokens"
msgstr "Input tokens"

#: src/routes/SystemPrompts.tsx:295
msgid "Internal name — used to pick this prompt from the models editor."
msgstr "Internal name — used to pick this prompt from the models editor."

#: src/credit-reason-labels.ts:16
msgid "Internal testing"
msgstr "Internal testing"

#: src/auth.tsx:261
msgid "Invalid email or password."
msgstr "Invalid email or password."

#: src/features-catalog.ts:79
msgid "Inventory Control"
msgstr "Inventory Control"

#: src/components/FeatureSelector.tsx:141
msgid "Irreversible postings (batches, adjustments)"
msgstr "Irreversible postings (batches, adjustments)"

#: src/routes/CustomerDetail.tsx:1224
msgid "Issue"
msgstr "Issue"

#: src/routes/CustomerDetail.tsx:512
#: src/routes/CustomerDetail.tsx:1184
msgid "Issue licence"
msgstr "Issue licence"

#: src/routes/CustomerDetail.tsx:521
msgid "Key"
msgstr "Key"

#. placeholder {0}: license.licenseKey
#. placeholder {1}: license.planCode
#: src/routes/CustomerDetail.tsx:1274
msgid "Key <0>{0}</0> — a transfer rotates this key. This licence's plan is <1>{1}</1>."
msgstr "Key <0>{0}</0> — a transfer rotates this key. This licence's plan is <1>{1}</1>."

#: src/routes/CustomerDetail.tsx:520
#: src/routes/CustomerDetail.tsx:1281
msgid "Label"
msgstr "Label"

#: src/routes/CustomerDetail.tsx:1201
msgid "Label (optional)"
msgstr "Label (optional)"

#: src/routes/Conversations.tsx:444
#: src/routes/Errors.tsx:313
msgid "last {currentTimeLabel}"
msgstr "last {currentTimeLabel}"

#: src/routes/Monitoring.tsx:148
msgid "Last error"
msgstr "Last error"

#: src/routes/CustomerDetail.tsx:662
#: src/routes/Monitoring.tsx:149
msgid "Last heartbeat"
msgstr "Last heartbeat"

#: src/routes/Users.tsx:72
msgid "Last sign-in"
msgstr "Last sign-in"

#: src/routes/Errors.tsx:224
#: src/routes/Errors.tsx:384
msgid "Level"
msgstr "Level"

#: src/routes/Usage.tsx:102
msgid "Licence"
msgstr "Licence"

#: src/routes/CustomerDetail.tsx:581
msgid "Licence actions"
msgstr "Licence actions"

#: src/routes/CustomerDetail.tsx:424
#: src/routes/Customers.tsx:262
msgid "Licence plans"
msgstr "Licence plans"

#: src/routes/CustomerDetail.tsx:511
msgid "Licences"
msgstr "Licences"

#: src/routes/LicenseSwaps.tsx:73
msgid "License ID (target)"
msgstr "License ID (target)"

#: src/components/Layout.tsx:186
#: src/routes/LicenseSwaps.tsx:59
msgid "License swaps"
msgstr "License swaps"

#: src/routes/Conversations.tsx:542
#: src/routes/Errors.tsx:437
msgid "Load more"
msgstr "Load more"

#: src/routes/LlmModels.tsx:156
msgid "Loading prices…"
msgstr "Loading prices…"

#: src/routes/LlmModels.tsx:452
msgid "Loading system prompts…"
msgstr "Loading system prompts…"

#: src/routes/AuditLog.tsx:90
#: src/routes/ConversationDetail.tsx:79
#: src/routes/Conversations.tsx:438
#: src/routes/Conversations.tsx:459
#: src/routes/Conversations.tsx:542
#: src/routes/CustomerDetail.tsx:384
#: src/routes/CustomerDetail.tsx:1045
#: src/routes/Customers.tsx:252
#: src/routes/Errors.tsx:308
#: src/routes/Errors.tsx:364
#: src/routes/Errors.tsx:437
#: src/routes/LicenseSwaps.tsx:118
#: src/routes/LlmModels.tsx:225
#: src/routes/Monitoring.tsx:133
#: src/routes/NewConfig.tsx:292
#: src/routes/Plans.tsx:158
#: src/routes/Releases.tsx:175
#: src/routes/SealSecrets.tsx:234
#: src/routes/SystemPrompts.tsx:151
#: src/routes/Usage.tsx:75
#: src/routes/Users.tsx:64
msgid "Loading…"
msgstr "Loading…"

#: src/routes/NewConfig.tsx:325
msgid "Local storage quota (MiB)"
msgstr "Local storage quota (MiB)"

#: src/components/RequestPricing.tsx:31
msgid "Long context"
msgstr "Long context"

#. placeholder {0}: p.longContext.inputTokenThreshold.toLocaleString(i18n.locale)
#: src/routes/LlmModels.tsx:184
msgid "Long context: input > {0} tokens"
msgstr "Long context: input > {0} tokens"

#: src/routes/LlmModels.tsx:609
msgid "Long-context tier"
msgstr "Long-context tier"

#: src/routes/LlmModels.tsx:437
msgid "Low"
msgstr "Low"

#: src/routes/ConversationDetail.tsx:182
#: src/routes/Conversations.tsx:321
#: src/routes/Conversations.tsx:477
#: src/routes/Errors.tsx:286
#: src/routes/Errors.tsx:385
#: src/routes/Monitoring.tsx:142
#: src/routes/Monitoring.tsx:203
msgid "Machine"
msgstr "Machine"

#: src/routes/CustomerDetail.tsx:709
msgid "Machine actions"
msgstr "Machine actions"

#: src/routes/SealSecrets.tsx:252
msgid "Machine public key fingerprint"
msgstr "Machine public key fingerprint"

#: src/routes/Errors.tsx:330
msgid "Machine: {selectedMachineName}"
msgstr "Machine: {selectedMachineName}"

#: src/routes/CustomerDetail.tsx:651
#: src/routes/Monitoring.tsx:85
#: src/routes/Monitoring.tsx:118
msgid "Machines"
msgstr "Machines"

#: src/routes/Customers.tsx:79
msgid "Manage →"
msgstr "Manage →"

#: src/routes/LlmModels.tsx:470
msgid "Manage system prompts"
msgstr "Manage system prompts"

#: src/routes/Releases.tsx:339
msgid "Mark as required (agents will highlight this in the UI)"
msgstr "Mark as required (agents will highlight this in the UI)"

#: src/routes/LlmModels.tsx:208
msgid "Max output"
msgstr "Max output"

#: src/routes/LlmModels.tsx:422
msgid "Max output tokens"
msgstr "Max output tokens"

#: src/routes/NewConfig.tsx:452
msgid "Max rows per query"
msgstr "Max rows per query"

#: src/routes/Plans.tsx:379
msgid "Max tool calls per turn"
msgstr "Max tool calls per turn"

#: src/routes/LlmModels.tsx:441
msgid "Maximum"
msgstr "Maximum"

#: src/routes/LlmModels.tsx:438
msgid "Medium — recommended"
msgstr "Medium — recommended"

#: src/routes/Errors.tsx:388
#: src/routes/Errors.tsx:453
#: src/routes/Monitoring.tsx:255
msgid "Message"
msgstr "Message"

#: src/routes/ConversationDetail.tsx:243
msgid "Messages"
msgstr "Messages"

#: src/routes/Users.tsx:199
msgid "min 8 characters"
msgstr "min 8 characters"

#: src/feedback-labels.ts:11
msgid "Missing access rights"
msgstr "Missing access rights"

#: src/feedback-labels.ts:17
msgid "Misunderstood the question"
msgstr "Misunderstood the question"

#: src/routes/Plans.tsx:139
#: src/routes/Plans.tsx:294
#: src/routes/SystemPrompts.tsx:324
#: src/routes/Usage.tsx:226
msgid "Model"
msgstr "Model"

#: src/routes/LlmModels.tsx:118
msgid "Model actions"
msgstr "Model actions"

#: src/routes/Usage.tsx:217
msgid "Model calls the product makes for itself. Not billed to any customer, not counted in any quota — this is our own cost."
msgstr "Model calls the product makes for itself. Not billed to any customer, not counted in any quota — this is our own cost."

#: src/routes/LlmModels.tsx:205
msgid "Model id"
msgstr "Model id"

#: src/routes/ConversationDetail.tsx:195
#: src/routes/SystemPrompts.tsx:126
msgid "Models"
msgstr "Models"

#: src/components/Layout.tsx:171
#: src/routes/LlmModels.tsx:220
msgid "Models & prices"
msgstr "Models & prices"

#: src/components/FeatureSelector.tsx:137
msgid "Module"
msgstr "Module"

#: src/components/Layout.tsx:180
#: src/routes/Monitoring.tsx:76
msgid "Monitoring"
msgstr "Monitoring"

#: src/routes/Usage.tsx:61
msgid "Month"
msgstr "Month"

#: src/routes/CustomerDetail.tsx:526
msgid "Monthly allowance"
msgstr "Monthly allowance"

#: src/routes/Plans.tsx:357
msgid "Monthly budget (USD)"
msgstr "Monthly budget (USD)"

#: src/routes/Conversations.tsx:479
msgid "Msgs"
msgstr "Msgs"

#: src/features-catalog.ts:133
msgid "Multiple Contacts"
msgstr "Multiple Contacts"

#: src/routes/CustomerDetail.tsx:658
#: src/routes/Customers.tsx:259
#: src/routes/Customers.tsx:382
#: src/routes/Plans.tsx:138
#: src/routes/Plans.tsx:290
#: src/routes/Users.tsx:70
#: src/routes/Users.tsx:187
msgid "Name"
msgstr "Name"

#: src/routes/CustomerDetail.tsx:704
#: src/routes/Monitoring.tsx:308
#: src/routes/Users.tsx:87
msgid "never"
msgstr "never"

#: src/routes/Users.tsx:60
#: src/routes/Users.tsx:168
msgid "New account"
msgstr "New account"

#: src/routes/Customers.tsx:247
#: src/routes/Customers.tsx:379
msgid "New customer"
msgstr "New customer"

#: src/routes/LlmModels.tsx:221
#: src/routes/LlmModels.tsx:381
msgid "New model"
msgstr "New model"

#. placeholder {0}: u.email
#: src/routes/Users.tsx:38
msgid "New password for {0}:"
msgstr "New password for {0}:"

#: src/routes/Plans.tsx:154
#: src/routes/Plans.tsx:277
msgid "New plan"
msgstr "New plan"

#. placeholder {0}: model.displayName
#: src/routes/LlmModels.tsx:544
msgid "New price for {0}"
msgstr "New price for {0}"

#: src/routes/SystemPrompts.tsx:145
msgid "New prompt"
msgstr "New prompt"

#: src/routes/SystemPrompts.tsx:286
msgid "New system prompt"
msgstr "New system prompt"

#: src/routes/Usage.tsx:269
msgid "Next"
msgstr "Next"

#: src/routes/CustomerDetail.tsx:1440
#: src/routes/CustomerDetail.tsx:1441
msgid "Next page"
msgstr "Next page"

#: src/routes/Releases.tsx:95
msgid "no"
msgstr "no"

#: src/routes/SystemPrompts.tsx:341
msgid "No active model."
msgstr "No active model."

#: src/routes/SystemPrompts.tsx:157
msgid "No active prompts yet."
msgstr "No active prompts yet."

#: src/routes/Releases.tsx:184
msgid "No active releases."
msgstr "No active releases."

#: src/feedback-labels.ts:14
msgid "No answer at all"
msgstr "No answer at all"

#: src/routes/Releases.tsx:177
msgid "No app versions published yet."
msgstr "No app versions published yet."

#: src/routes/Releases.tsx:190
msgid "No archived releases."
msgstr "No archived releases."

#: src/routes/AuditLog.tsx:146
msgid "No audit entries match."
msgstr "No audit entries match."

#: src/routes/ConversationDetail.tsx:489
msgid "No comment provided."
msgstr "No comment provided."

#: src/routes/NewConfig.tsx:314
msgid "No config yet for this customer. Saving creates the first revision and pushes it out."
msgstr "No config yet for this customer. Saving creates the first revision and pushes it out."

#: src/routes/CustomerDetail.tsx:776
msgid "No config yet."
msgstr "No config yet."

#: src/routes/Conversations.tsx:462
msgid "No conversation matches these filters."
msgstr "No conversation matches these filters."

#: src/routes/Customers.tsx:254
msgid "No customers yet."
msgstr "No customers yet."

#: src/routes/Errors.tsx:367
msgid "No errors match these filters."
msgstr "No errors match these filters."

#: src/routes/Monitoring.tsx:194
msgid "No errors reported in the last 24h."
msgstr "No errors reported in the last 24h."

#: src/routes/CustomerDetail.tsx:971
msgid "No feature active."
msgstr "No feature active."

#: src/routes/CustomerDetail.tsx:515
msgid "No licence issued yet."
msgstr "No licence issued yet."

#: src/routes/CustomerDetail.tsx:637
msgid "No licence usage."
msgstr "No licence usage."

#: src/routes/LicenseSwaps.tsx:178
msgid "No license swaps match."
msgstr "No license swaps match."

#: src/routes/CustomerDetail.tsx:653
msgid "No machine registered yet."
msgstr "No machine registered yet."

#: src/routes/Monitoring.tsx:135
msgid "No machines match this filter."
msgstr "No machines match this filter."

#: src/routes/CustomerDetail.tsx:1432
#~ msgid "No model usage."
#~ msgstr "No model usage."

#: src/routes/LlmModels.tsx:158
msgid "No price version yet."
msgstr "No price version yet."

#: src/routes/CustomerDetail.tsx:1529
msgid "No prior months on record."
msgstr "No prior months on record."

#: src/routes/ConversationDetail.tsx:283
msgid "No recorded requests."
msgstr "No recorded requests."

#: src/routes/Monitoring.tsx:246
msgid "No runtime errors in the last 24h."
msgstr "No runtime errors in the last 24h."

#: src/components/RequestPricing.tsx:34
msgid "No threshold recorded"
msgstr "No threshold recorded"

#: src/routes/Usage.tsx:158
msgid "No usage recorded this month."
msgstr "No usage recorded this month."

#: src/routes/LlmModels.tsx:436
msgid "None — lowest latency"
msgstr "None — lowest latency"

#: src/components/FeatureSelector.tsx:192
msgid "not applicable"
msgstr "not applicable"

#: src/routes/Conversations.tsx:79
msgid "Not flagged"
msgstr "Not flagged"

#: src/routes/ConversationDetail.tsx:388
msgid "Note (optional)"
msgstr "Note (optional)"

#: src/routes/ConversationDetail.tsx:388
msgid "Note (required)"
msgstr "Note (required)"

#: src/routes/Customers.tsx:403
msgid "Notes"
msgstr "Notes"

#: src/routes/SealSecrets.tsx:163
msgid "Nothing to change."
msgstr "Nothing to change."

#: src/routes/CustomerDetail.tsx:557
msgid "Occupied"
msgstr "Occupied"

#: src/components/FeatureSelector.tsx:140
msgid "OData create / update / delete"
msgstr "OData create / update / delete"

#: src/components/FeatureSelector.tsx:139
msgid "OData list / get / search"
msgstr "OData list / get / search"

#: src/routes/Monitoring.tsx:126
#: src/routes/Monitoring.tsx:164
msgid "offline"
msgstr "offline"

#: src/routes/Monitoring.tsx:87
msgid "Offline"
msgstr "Offline"

#. placeholder {0}: summary.offlineThresholdMinutes
#: src/routes/Monitoring.tsx:112
msgid "Offline threshold: {0} min without heartbeat."
msgstr "Offline threshold: {0} min without heartbeat."

#: src/routes/Monitoring.tsx:296
msgid "ok"
msgstr "ok"

#: src/routes/AuditLog.tsx:165
#: src/routes/LicenseSwaps.tsx:197
msgid "Older →"
msgstr "Older →"

#: src/components/RequestPricing.tsx:48
msgid "Omitted cache rates use this request's selected input rate. Explicit zero rates remain zero. Historical costs are displayed as recorded."
msgstr "Omitted cache rates use this request's selected input rate. Explicit zero rates remain zero. Historical costs are displayed as recorded."

#: src/routes/Monitoring.tsx:126
#: src/routes/Monitoring.tsx:164
msgid "online"
msgstr "online"

#: src/routes/Monitoring.tsx:86
msgid "Online"
msgstr "Online"

#: src/routes/LlmModels.tsx:444
msgid "Only applied to OpenAI models; Anthropic ignores this field."
msgstr "Only applied to OpenAI models; Anthropic ignores this field."

#: src/routes/Releases.tsx:104
msgid "open"
msgstr "open"

#: src/components/TransferLicenseDialog.tsx:31
msgid "Open Machine identity on the replacement desktop and copy its fingerprint here."
msgstr "Open Machine identity on the replacement desktop and copy its fingerprint here."

#: src/components/Layout.tsx:178
msgid "Operations"
msgstr "Operations"

#: src/routes/Users.tsx:190
msgid "optional"
msgstr "optional"

#: src/features-catalog.ts:72
msgid "Order Entry"
msgstr "Order Entry"

#: src/routes/Errors.tsx:245
#: src/routes/Errors.tsx:383
#: src/routes/Monitoring.tsx:253
msgid "Origin"
msgstr "Origin"

#: src/credit-reason-labels.ts:20
#: src/feedback-labels.ts:19
msgid "Other"
msgstr "Other"

#: src/routes/ConversationDetail.tsx:446
msgid "out"
msgstr "out"

#: src/routes/LicenseSwaps.tsx:84
#: src/routes/LicenseSwaps.tsx:133
msgid "Outcome"
msgstr "Outcome"

#: src/routes/Conversations.tsx:484
#: src/routes/Usage.tsx:229
msgid "Output"
msgstr "Output"

#: src/routes/LlmModels.tsx:592
#: src/routes/LlmModels.tsx:632
msgid "Output $/1M tokens"
msgstr "Output $/1M tokens"

#: src/routes/LlmModels.tsx:170
msgid "Output $/Mtok"
msgstr "Output $/Mtok"

#: src/components/RequestPricing.tsx:44
#: src/routes/ConversationDetail.tsx:267
#: src/routes/ConversationDetail.tsx:445
#: src/routes/CustomerDetail.tsx:634
#: src/routes/CustomerDetail.tsx:1356
#: src/routes/Usage.tsx:89
msgid "Output tokens"
msgstr "Output tokens"

#. placeholder {0}: creditedPageSafe + 1
#: src/routes/CustomerDetail.tsx:1425
msgid "Page {0} of {creditedPageCount}"
msgstr "Page {0} of {creditedPageCount}"

#. placeholder {0}: Math.max(1, Math.ceil(data.requestPagination.total / data.requestPagination.pageSize))
#: src/routes/Usage.tsx:268
msgid "Page {page} of {0}"
msgstr "Page {page} of {0}"

#: src/routes/Login.tsx:32
#: src/routes/Users.tsx:196
msgid "Password"
msgstr "Password"

#: src/routes/Users.tsx:41
#: src/routes/Users.tsx:146
msgid "Password must be at least 8 characters."
msgstr "Password must be at least 8 characters."

#: src/routes/Users.tsx:47
msgid "Password updated."
msgstr "Password updated."

#: src/routes/NewConfig.tsx:566
msgid "Passwords are not set here. Once this config is saved, use \"Seal secrets\" on each machine to choose which companies that machine may query and send their credentials encrypted."
msgstr "Passwords are not set here. Once this config is saved, use \"Seal secrets\" on each machine to choose which companies that machine may query and send their credentials encrypted."

#: src/routes/SealSecrets.tsx:256
msgid "Passwords typed below are sealed in this browser with the machine's public key and never sent in the clear. After sealing, the plaintext is discarded from the form."
msgstr "Passwords typed below are sealed in this browser with the machine's public key and never sent in the clear. After sealing, the plaintext is discarded from the form."

#: src/routes/CustomerDetail.tsx:466
msgid "Pause (unpaid)"
msgstr "Pause (unpaid)"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:350
msgid "Pause {0} for non-payment? Access is cut until you unpause. Optional note:"
msgstr "Pause {0} for non-payment? Access is cut until you unpause. Optional note:"

#: src/routes/Customers.tsx:35
msgid "paused"
msgstr "paused"

#: src/routes/CustomerDetail.tsx:489
msgid "Paused for non-payment"
msgstr "Paused for non-payment"

#: src/components/FeatureSelector.tsx:61
msgid "Pick what the LLM is allowed to touch. <0>.write</0> and <1>.read</1> per module control the Sage Web API; <2>db.*.read</2> control the read-only SQL surface. See <3>docs/permissions.md</3> for the full reference."
msgstr "Pick what the LLM is allowed to touch. <0>.write</0> and <1>.read</1> per module control the Sage Web API; <2>db.*.read</2> control the read-only SQL surface. See <3>docs/permissions.md</3> for the full reference."

#: src/components/ChangeLicensePlanDialog.tsx:53
#: src/routes/CustomerDetail.tsx:522
#: src/routes/CustomerDetail.tsx:1192
#: src/routes/Usage.tsx:103
msgid "Plan"
msgstr "Plan"

#: src/routes/AuditLog.tsx:69
msgid "plan / customer / license…"
msgstr "plan / customer / license…"

#: src/routes/Plans.tsx:104
msgid "Plan actions"
msgstr "Plan actions"

#: src/components/Layout.tsx:170
#: src/routes/Plans.tsx:153
msgid "Plans"
msgstr "Plans"

#: src/routes/Usage.tsx:256
msgid "Platform requests"
msgstr "Platform requests"

#: src/routes/Usage.tsx:215
msgid "Platform spend (Jalfa)"
msgstr "Platform spend (Jalfa)"

#: src/routes/SystemPrompts.tsx:123
msgid "Preview"
msgstr "Preview"

#: src/routes/Usage.tsx:267
msgid "Previous"
msgstr "Previous"

#: src/routes/CustomerDetail.tsx:1431
#: src/routes/CustomerDetail.tsx:1432
msgid "Previous page"
msgstr "Previous page"

#: src/routes/LlmModels.tsx:122
msgid "Prices"
msgstr "Prices"

#: src/routes/LlmModels.tsx:166
msgid "Pricing tier"
msgstr "Pricing tier"

#: src/credit-reason-labels.ts:12
msgid "Product bug"
msgstr "Product bug"

#: src/features-catalog.ts:87
msgid "Project & Job Costing"
msgstr "Project & Job Costing"

#: src/components/ChangeLicensePlanDialog.tsx:66
msgid "Proposed retention: {proposedDays} days."
msgstr "Proposed retention: {proposedDays} days."

#: src/routes/LlmModels.tsx:204
#: src/routes/LlmModels.tsx:384
msgid "Provider"
msgstr "Provider"

#: src/routes/LlmModels.tsx:395
msgid "Provider model id"
msgstr "Provider model id"

#: src/routes/ConversationDetail.tsx:275
msgid "Provider request pricing"
msgstr "Provider request pricing"

#: src/routes/Releases.tsx:361
msgid "Publish"
msgstr "Publish"

#: src/routes/Releases.tsx:167
#: src/routes/Releases.tsx:278
msgid "Publish new version"
msgstr "Publish new version"

#: src/routes/Releases.tsx:147
msgid "Published"
msgstr "Published"

#: src/features-catalog.ts:64
msgid "Purchase Orders"
msgstr "Purchase Orders"

#: src/routes/Usage.tsx:225
msgid "Purpose"
msgstr "Purpose"

#: src/routes/Usage.tsx:260
msgid "Question rewrite"
msgstr "Question rewrite"

#: src/routes/Plans.tsx:326
msgid "Question rewrite model"
msgstr "Question rewrite model"

#: src/routes/Conversations.tsx:78
msgid "Rated"
msgstr "Rated"

#: src/routes/Users.tsx:102
msgid "Re-enable"
msgstr "Re-enable"

#: src/routes/CustomerDetail.tsx:597
#: src/routes/CustomerDetail.tsx:730
#: src/routes/LlmModels.tsx:146
#: src/routes/Plans.tsx:124
msgid "Reactivate"
msgstr "Reactivate"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:335
msgid "Reactivate {0}? Licences resume at the next agent request."
msgstr "Reactivate {0}? Licences resume at the next agent request."

#: src/routes/CustomerDetail.tsx:442
msgid "Reactivate customer"
msgstr "Reactivate customer"

#. placeholder {0}: l.licenseKey
#: src/routes/CustomerDetail.tsx:266
msgid "Reactivate licence {0}?"
msgstr "Reactivate licence {0}?"

#. placeholder {0}: m.displayName
#: src/routes/LlmModels.tsx:79
msgid "Reactivate model \"{0}\"?"
msgstr "Reactivate model \"{0}\"?"

#. placeholder {0}: p.code
#: src/routes/Plans.tsx:57
msgid "Reactivate plan \"{0}\"?"
msgstr "Reactivate plan \"{0}\"?"

#: src/routes/NewConfig.tsx:543
msgid "Reactivate this company"
msgstr "Reactivate this company"

#: src/routes/CustomerDetail.tsx:237
msgid "Reactivate this machine? The agent will resume at its next request."
msgstr "Reactivate this machine? The agent will resume at its next request."

#: src/components/FeatureSelector.tsx:138
msgid "Read-only SQL query tool (sage300_db_*_query)"
msgstr "Read-only SQL query tool (sage300_db_*_query)"

#: src/routes/ConversationDetail.tsx:375
#: src/routes/CustomerDetail.tsx:1395
msgid "Reason"
msgstr "Reason"

#: src/routes/LlmModels.tsx:209
msgid "Reasoning"
msgstr "Reasoning"

#: src/routes/LlmModels.tsx:431
msgid "Reasoning effort"
msgstr "Reasoning effort"

#: src/routes/CustomerDetail.tsx:1063
msgid "Reassign"
msgstr "Reassign"

#: src/routes/CustomerDetail.tsx:409
#: src/routes/CustomerDetail.tsx:1034
msgid "Reassign reseller"
msgstr "Reassign reseller"

#. placeholder {0}: new Date(entry.receivedAt).toLocaleString(i18n.locale)
#. placeholder {1}: entry.id
#: src/routes/Errors.tsx:487
msgid "Received {0} · id {1}"
msgstr "Received {0} · id {1}"

#: src/routes/Monitoring.tsx:191
msgid "Recent errors (24h)"
msgstr "Recent errors (24h)"

#: src/routes/ConversationDetail.tsx:276
msgid "Recorded customer costs and rates. Input tokens include cache reads and writes. Rates are USD per million tokens."
msgstr "Recorded customer costs and rates. Input tokens include cache reads and writes. Rates are USD per million tokens."

#: src/components/RequestPricing.tsx:39
msgid "Recorded rate (USD / million tokens)"
msgstr "Recorded rate (USD / million tokens)"

#: src/routes/AuditLog.tsx:84
#: src/routes/Conversations.tsx:253
#: src/routes/Errors.tsx:177
#: src/routes/LicenseSwaps.tsx:112
#: src/routes/Monitoring.tsx:78
#: src/routes/Usage.tsx:69
msgid "Refresh"
msgstr "Refresh"

#: src/routes/Conversations.tsx:253
#: src/routes/Errors.tsx:177
msgid "Refreshing…"
msgstr "Refreshing…"

#: src/routes/LicenseSwaps.tsx:94
msgid "rejected"
msgstr "rejected"

#: src/routes/Releases.tsx:110
msgid "Release actions"
msgstr "Release actions"

#: src/routes/Releases.tsx:342
msgid "Release notes (Markdown)"
msgstr "Release notes (Markdown)"

#: src/components/Layout.tsx:197
#: src/routes/Releases.tsx:164
msgid "Releases"
msgstr "Releases"

#: src/routes/Usage.tsx:112
msgid "Remaining allowance"
msgstr "Remaining allowance"

#: src/routes/Usage.tsx:93
msgid "Remaining allowance shows budget and hard cap slack for each licence."
msgstr "Remaining allowance shows budget and hard cap slack for each licence."

#: src/routes/CustomerDetail.tsx:625
msgid "Remaining budget"
msgstr "Remaining budget"

#: src/routes/CustomerDetail.tsx:752
#: src/routes/NewConfig.tsx:298
msgid "Remote config"
msgstr "Remote config"

#: src/routes/ConversationDetail.tsx:136
msgid "Remove credit"
msgstr "Remove credit"

#: src/routes/Errors.tsx:514
msgid "Remove filter"
msgstr "Remove filter"

#: src/routes/ConversationDetail.tsx:58
msgid "Remove the credit? This conversation becomes billable again and reappears in the customer's app."
msgstr "Remove the credit? This conversation becomes billable again and reappears in the customer's app."

#. placeholder {0}: c.originalId
#: src/routes/NewConfig.tsx:409
msgid "Renaming \"{0}\" will orphan its sealed passwords — every machine will have to be re-sealed for this company."
msgstr "Renaming \"{0}\" will orphan its sealed passwords — every machine will have to be re-sealed for this company."

#: src/routes/CustomerDetail.tsx:848
msgid "Replacement authorized"
msgstr "Replacement authorized"

#: src/components/TransferLicenseDialog.tsx:35
msgid "Replacement public key fingerprint"
msgstr "Replacement public key fingerprint"

#: src/routes/ConversationDetail.tsx:475
msgid "reported"
msgstr "reported"

#: src/routes/Conversations.tsx:391
msgid "Reported reason"
msgstr "Reported reason"

#: src/routes/Conversations.tsx:571
msgid "Reported without a reason"
msgstr "Reported without a reason"

#: src/components/RequestPricing.tsx:24
msgid "Request"
msgstr "Request"

#: src/routes/Errors.tsx:463
msgid "Request ID"
msgstr "Request ID"

#: src/routes/ConversationDetail.tsx:289
msgid "Requests without a turn (including titles)"
msgstr "Requests without a turn (including titles)"

#: src/routes/Releases.tsx:146
msgid "Required"
msgstr "Required"

#: src/routes/CustomerDetail.tsx:407
#: src/routes/CustomerDetail.tsx:1043
#: src/routes/Customers.tsx:232
#: src/routes/Customers.tsx:261
#: src/routes/Users.tsx:84
msgid "Reseller"
msgstr "Reseller"

#: src/routes/Users.tsx:174
msgid "Reseller (scoped to their own customers)"
msgstr "Reseller (scoped to their own customers)"

#: src/routes/CustomerDetail.tsx:1540
msgid "Reservation"
msgstr "Reservation"

#: src/routes/Conversations.tsx:250
#: src/routes/Errors.tsx:174
msgid "Reset"
msgstr "Reset"

#: src/routes/Users.tsx:95
msgid "Reset password"
msgstr "Reset password"

#: src/routes/Plans.tsx:142
msgid "Retention"
msgstr "Retention"

#: src/routes/Plans.tsx:388
msgid "Retention (days)"
msgstr "Retention (days)"

#. placeholder {0}: c.version
#. placeholder {1}: new Date(c.createdAt).toLocaleString(i18n.locale)
#. placeholder {2}: activeId ? ` · default ${activeId}` : ""
#: src/routes/CustomerDetail.tsx:760
msgid "rev {0} · {1}{2}"
msgstr "rev {0} · {1}{2}"

#: src/routes/CustomerDetail.tsx:721
msgid "Revoke"
msgstr "Revoke"

#: src/routes/CustomerDetail.tsx:224
msgid "Revoke this machine? The agent will be locked out at the next request."
msgstr "Revoke this machine? The agent will be locked out at the next request."

#: src/routes/Monitoring.tsx:88
msgid "Revoked"
msgstr "Revoked"

#: src/routes/CustomerDetail.tsx:557
msgid "Revoking previous access"
msgstr "Revoking previous access"

#. placeholder {0}: rewriteModel.displayName
#: src/routes/Plans.tsx:94
msgid "rewrite: {0}"
msgstr "rewrite: {0}"

#: src/routes/Plans.tsx:339
msgid "Rewrites the user's question into the English accounting vocabulary of the Sage schema before the database discovery tools search it — the metadata is in English and the questions are not. Cheapest active model; leaving it off falls back to the built-in French lexicon. Billed to Jalfa, not to the customer (Usage → platform spend)."
msgstr "Rewrites the user's question into the English accounting vocabulary of the Sage schema before the database discovery tools search it — the metadata is in English and the questions are not. Cheapest active model; leaving it off falls back to the built-in French lexicon. Billed to Jalfa, not to the customer (Usage → platform spend)."

#: src/routes/Users.tsx:71
#: src/routes/Users.tsx:171
msgid "Role"
msgstr "Role"

#: src/routes/Monitoring.tsx:105
#: src/routes/Monitoring.tsx:242
msgid "Runtime errors (24h)"
msgstr "Runtime errors (24h)"

#. placeholder {0}: index + 1
#: src/routes/NewConfig.tsx:345
msgid "Sage 300 company {0}"
msgstr "Sage 300 company {0}"

#: src/routes/SealSecrets.tsx:308
msgid "Sage 300 Web API password"
msgstr "Sage 300 Web API password"

#: src/components/TransferLicenseDialog.tsx:33
msgid "Sage credentials and local files are not copied. Configure and seal Sage access on the replacement, including the company selected by each retained conversation."
msgstr "Sage credentials and local files are not copied. Configure and seal Sage access on the replacement, including the company selected by each retained conversation."

#: src/features-catalog.ts:128
msgid "Sage CRM Integration"
msgstr "Sage CRM Integration"

#: src/features-catalog.ts:123
msgid "Sage Fixed Assets Integration"
msgstr "Sage Fixed Assets Integration"

#: src/routes/Monitoring.tsx:145
msgid "Sage SQL"
msgstr "Sage SQL"

#: src/routes/CustomerDetail.tsx:429
#: src/routes/CustomerDetail.tsx:1113
msgid "Sage version"
msgstr "Sage version"

#: src/routes/CustomerDetail.tsx:792
#: src/routes/Monitoring.tsx:146
#: src/routes/NewConfig.tsx:485
msgid "Sage Web API"
msgstr "Sage Web API"

#: src/feedback-labels.ts:12
msgid "Said it could not answer"
msgstr "Said it could not answer"

#: src/routes/CustomerDetail.tsx:1132
#: src/routes/CustomerDetail.tsx:1304
#: src/routes/LlmModels.tsx:479
#: src/routes/LlmModels.tsx:644
#: src/routes/NewConfig.tsx:589
#: src/routes/Plans.tsx:402
#: src/routes/Releases.tsx:359
#: src/routes/SystemPrompts.tsx:379
msgid "Save"
msgstr "Save"

#: src/components/ChangeLicensePlanDialog.tsx:80
#: src/components/TransferLicenseDialog.tsx:47
#: src/routes/CustomerDetail.tsx:1063
#: src/routes/CustomerDetail.tsx:1132
#: src/routes/CustomerDetail.tsx:1304
#: src/routes/LlmModels.tsx:479
#: src/routes/LlmModels.tsx:644
#: src/routes/NewConfig.tsx:589
#: src/routes/Plans.tsx:402
#: src/routes/Releases.tsx:357
#: src/routes/SystemPrompts.tsx:379
msgid "Saving…"
msgstr "Saving…"

#: src/routes/SealSecrets.tsx:351
msgid "Seal & upload"
msgstr "Seal & upload"

#: src/routes/CustomerDetail.tsx:708
#: src/routes/CustomerDetail.tsx:713
#: src/routes/SealSecrets.tsx:240
msgid "Seal secrets"
msgstr "Seal secrets"

#: src/routes/SealSecrets.tsx:215
msgid "Sealed {stored} secret(s) and revoked {deleted}. The machine will pick up the change over the WebSocket push — no restart needed."
msgstr "Sealed {stored} secret(s) and revoked {deleted}. The machine will pick up the change over the WebSocket push — no restart needed."

#: src/routes/SealSecrets.tsx:351
msgid "Sealing…"
msgstr "Sealing…"

#: src/routes/Conversations.tsx:268
msgid "Search by title…"
msgstr "Search by title…"

#: src/routes/Errors.tsx:192
msgid "Search message, source or error code…"
msgstr "Search message, source or error code…"

#: src/routes/Plans.tsx:234
msgid "Select a model first"
msgstr "Select a model first"

#: src/routes/CustomerDetail.tsx:1194
msgid "Select a plan"
msgstr "Select a plan"

#: src/routes/LlmModels.tsx:460
msgid "Select a system prompt…"
msgstr "Select a system prompt…"

#: src/components/FeatureSelector.tsx:71
msgid "Select all SQL read"
msgstr "Select all SQL read"

#: src/components/FeatureSelector.tsx:78
msgid "Select all Web API read"
msgstr "Select all Web API read"

#: src/components/FeatureSelector.tsx:86
msgid "Select all Web API write + post"
msgstr "Select all Web API write + post"

#: src/routes/CustomerDetail.tsx:1186
msgid "Select this licence's plan before installation. Its plan provides an independent monthly allowance."
msgstr "Select this licence's plan before installation. Its plan provides an independent monthly allowance."

#: src/routes/NewConfig.tsx:431
msgid "Server"
msgstr "Server"

#: src/routes/CustomerDetail.tsx:768
msgid "Set up"
msgstr "Set up"

#: src/routes/Releases.tsx:150
msgid "SHA-256"
msgstr "SHA-256"

#: src/routes/Releases.tsx:320
msgid "SHA-256 (64 hex chars)"
msgstr "SHA-256 (64 hex chars)"

#: src/components/ChangeLicensePlanDialog.tsx:69
msgid "Shortening retention will permanently delete existing history older than {proposedDays} days at the next retention sweep. Changing plans does not restart the age of existing history."
msgstr "Shortening retention will permanently delete existing history older than {proposedDays} days at the next retention sweep. Changing plans does not restart the age of existing history."

#: src/routes/NewConfig.tsx:364
msgid "Shown to the user in the app when they pick a company."
msgstr "Shown to the user in the app when they pick a company."

#: src/routes/Login.tsx:43
msgid "Sign in"
msgstr "Sign in"

#: src/routes/Login.tsx:19
msgid "Sign in with your administrator account."
msgstr "Sign in with your administrator account."

#: src/components/Layout.tsx:246
msgid "Sign out"
msgstr "Sign out"

#: src/routes/Releases.tsx:330
msgid "Signature (optional, base64)"
msgstr "Signature (optional, base64)"

#: src/auth.tsx:208
msgid "Signed out after {IDLE_TIMEOUT_MINUTES} minutes without activity. Please sign in again."
msgstr "Signed out after {IDLE_TIMEOUT_MINUTES} minutes without activity. Please sign in again."

#: src/routes/Login.tsx:43
msgid "Signing in…"
msgstr "Signing in…"

#. placeholder {0}: new Date(customer.deactivatedAt).toLocaleString(i18n.locale)
#. placeholder {0}: new Date(customer.pausedAt).toLocaleString(i18n.locale)
#: src/routes/CustomerDetail.tsx:479
#: src/routes/CustomerDetail.tsx:491
msgid "since {0}"
msgstr "since {0}"

#: src/routes/Errors.tsx:387
#: src/routes/Monitoring.tsx:201
#: src/routes/Monitoring.tsx:254
msgid "Source"
msgstr "Source"

#: src/routes/Usage.tsx:106
msgid "Spent (mo)"
msgstr "Spent (mo)"

#: src/components/FeatureSelector.tsx:138
#: src/features-catalog.ts:160
msgid "SQL read"
msgstr "SQL read"

#: src/routes/CustomerDetail.tsx:791
msgid "SQL Server"
msgstr "SQL Server"

#: src/routes/NewConfig.tsx:429
msgid "SQL Server (read-only)"
msgstr "SQL Server (read-only)"

#: src/routes/SealSecrets.tsx:319
msgid "SQL Server password"
msgstr "SQL Server password"

#: src/routes/Errors.tsx:476
msgid "Stack"
msgstr "Stack"

#: src/components/RequestPricing.tsx:31
#: src/routes/LlmModels.tsx:178
msgid "Standard"
msgstr "Standard"

#: src/routes/CustomerDetail.tsx:523
#: src/routes/CustomerDetail.tsx:629
#: src/routes/CustomerDetail.tsx:659
#: src/routes/CustomerDetail.tsx:793
#: src/routes/Monitoring.tsx:143
#: src/routes/Usage.tsx:113
#: src/routes/Users.tsx:73
msgid "Status"
msgstr "Status"

#: src/routes/CustomerDetail.tsx:1346
msgid "Summed licence allowances"
msgstr "Summed licence allowances"

#: src/routes/CustomerDetail.tsx:1347
msgid "Summed licence hard caps"
msgstr "Summed licence hard caps"

#: src/routes/Users.tsx:85
msgid "Superuser"
msgstr "Superuser"

#: src/routes/Users.tsx:173
msgid "Superuser (Jalfa employee — full access)"
msgstr "Superuser (Jalfa employee — full access)"

#: src/credit-reason-labels.ts:15
msgid "Support investigation"
msgstr "Support investigation"

#: src/routes/CustomerDetail.tsx:605
msgid "Suspend"
msgstr "Suspend"

#. placeholder {0}: l.licenseKey
#: src/routes/CustomerDetail.tsx:252
msgid "Suspend licence {0}? Agents on this key will stop working immediately."
msgstr "Suspend licence {0}? Agents on this key will stop working immediately."

#: src/routes/LicenseSwaps.tsx:107
msgid "swap_check"
msgstr "swap_check"

#: src/routes/LicenseSwaps.tsx:108
msgid "swap_commit"
msgstr "swap_commit"

#: src/components/Layout.tsx:191
msgid "System"
msgstr "System"

#: src/routes/LlmModels.tsx:448
msgid "System prompt"
msgstr "System prompt"

#: src/routes/SystemPrompts.tsx:87
msgid "System prompt actions"
msgstr "System prompt actions"

#: src/routes/LlmModels.tsx:339
msgid "System prompt is required"
msgstr "System prompt is required"

#: src/components/Layout.tsx:196
#: src/routes/SystemPrompts.tsx:142
msgid "System prompts"
msgstr "System prompts"

#: src/routes/LicenseSwaps.tsx:131
msgid "Target license"
msgstr "Target license"

#: src/features-catalog.ts:145
msgid "Tax Services"
msgstr "Tax Services"

#: src/credit-reason-labels.ts:14
#: src/feedback-labels.ts:18
msgid "Technical or tool error"
msgstr "Technical or tool error"

#: src/routes/NewConfig.tsx:502
msgid "Tenant"
msgstr "Tenant"

#: src/routes/CustomerDetail.tsx:1036
msgid "The customer keeps its licences, machines and history — only the ownership changes. The new reseller sees this customer on their next dashboard load."
msgstr "The customer keeps its licences, machines and history — only the ownership changes. The new reseller sees this customer on their next dashboard load."

#: src/routes/Releases.tsx:281
msgid "The download URL must serve the exact bytes hashed by <0>sha256</0>. Agents refuse to install any package whose SHA-256 does not match."
msgstr "The download URL must serve the exact bytes hashed by <0>sha256</0>. Agents refuse to install any package whose SHA-256 does not match."

#: src/components/TransferLicenseDialog.tsx:32
msgid "The previous machine will lose access and the licence key will rotate. History, plan, permissions and consumption stay with this licence."
msgstr "The previous machine will lose access and the licence key will rotate. History, plan, permissions and consumption stay with this licence."

#: src/routes/SealSecrets.tsx:276
msgid "The remote config declares no company yet."
msgstr "The remote config declares no company yet."

#: src/routes/CustomerDetail.tsx:1386
msgid "These conversations are billed to nobody and are hidden from the customer's app. Together they account for the credited total above."
msgstr "These conversations are billed to nobody and are hidden from the customer's app. Together they account for the credited total above."

#: src/routes/SealSecrets.tsx:330
msgid "This company has neither complete SQL nor complete Web API settings, so there is no password to seal. Fix the config first."
msgstr "This company has neither complete SQL nor complete Web API settings, so there is no password to seal. Fix the config first."

#: src/routes/ConversationDetail.tsx:297
msgid "This conversation has no messages yet."
msgstr "This conversation has no messages yet."

#: src/routes/ConversationDetail.tsx:209
msgid "This conversation is billed to nobody and is hidden from the customer's app."
msgstr "This conversation is billed to nobody and is hidden from the customer's app."

#: src/routes/NewConfig.tsx:401
msgid "This id is used by another company. Ids prefix the sealed secret keys, so two companies cannot share one."
msgstr "This id is used by another company. Ids prefix the sealed secret keys, so two companies cannot share one."

#: src/routes/CustomerDetail.tsx:244
msgid "This license is occupied or the machine has no license. Administrator authorization is required before it can return."
msgstr "This license is occupied or the machine has no license. Administrator authorization is required before it can return."

#: src/routes/SealSecrets.tsx:168
msgid "This machine will lose access to: {names}. Continue?"
msgstr "This machine will lose access to: {names}. Continue?"

#: src/routes/SealSecrets.tsx:268
msgid "Tick a company to give this machine access to its database. Leave a password blank on an already-sealed company to keep the current one."
msgstr "Tick a company to give this machine access to its database. Leave a password blank on an already-sealed company to keep the current one."

#: src/routes/Conversations.tsx:285
#: src/routes/Errors.tsx:209
msgid "Time range"
msgstr "Time range"

#: src/routes/Conversations.tsx:475
msgid "Title"
msgstr "Title"

#: src/routes/ConversationDetail.tsx:231
msgid "Title cost"
msgstr "Title cost"

#: src/routes/Plans.tsx:305
msgid "Title model"
msgstr "Title model"

#. placeholder {0}: titleModel.displayName
#: src/routes/Plans.tsx:89
msgid "titles: {0}"
msgstr "titles: {0}"

#: src/components/RequestPricing.tsx:39
msgid "Token usage"
msgstr "Token usage"

#: src/components/RequestPricing.tsx:39
#: src/routes/SystemPrompts.tsx:327
msgid "Tokens"
msgstr "Tokens"

#: src/routes/SystemPrompts.tsx:313
msgid "Tokens estimated at ~4 characters per token; cost uses each active model's current input tariff."
msgstr "Tokens estimated at ~4 characters per token; cost uses each active model's current input tariff."

#: src/routes/CustomerDetail.tsx:627
#: src/routes/Plans.tsx:141
#: src/routes/Usage.tsx:111
msgid "Tolerance"
msgstr "Tolerance"

#: src/routes/Plans.tsx:368
msgid "Tolerance (%)"
msgstr "Tolerance (%)"

#: src/routes/Conversations.tsx:67
msgid "Tool error"
msgstr "Tool error"

#: src/routes/Usage.tsx:248
msgid "Total"
msgstr "Total"

#. placeholder {0}: formatCost(totals.cost, i18n.locale)
#: src/routes/Conversations.tsx:449
msgid "total {0}"
msgstr "total {0}"

#: src/routes/ConversationDetail.tsx:218
#: src/routes/CustomerDetail.tsx:1345
#: src/routes/Usage.tsx:79
msgid "Total cost"
msgstr "Total cost"

#: src/components/TransferLicenseDialog.tsx:30
#: src/routes/CustomerDetail.tsx:584
msgid "Transfer licence"
msgstr "Transfer licence"

#: src/routes/ConversationDetail.tsx:426
msgid "truncated (quota)"
msgstr "truncated (quota)"

#: src/routes/NewConfig.tsx:479
msgid "Trust server certificate (required on stock Sage 300 installs with a self-signed SQL Server cert)"
msgstr "Trust server certificate (required on stock Sage 300 installs with a self-signed SQL Server cert)"

#: src/routes/CustomerDetail.tsx:1541
msgid "Turn"
msgstr "Turn"

#. placeholder {0}: index + 1
#: src/routes/ConversationDetail.tsx:280
msgid "Turn {0}"
msgstr "Turn {0}"

#: src/routes/Conversations.tsx:68
msgid "Turn error"
msgstr "Turn error"

#: src/routes/ConversationDetail.tsx:237
#: src/routes/Conversations.tsx:480
#: src/routes/CustomerDetail.tsx:635
#: src/routes/CustomerDetail.tsx:1360
#: src/routes/Usage.tsx:122
msgid "Turns"
msgstr "Turns"

#. placeholder {0}: [...duplicateIds].join(", ")
#: src/routes/NewConfig.tsx:273
msgid "Two companies share the same id: {0}"
msgstr "Two companies share the same id: {0}"

#: src/routes/Releases.tsx:122
#: src/routes/SystemPrompts.tsx:107
msgid "Unarchive"
msgstr "Unarchive"

#. placeholder {0}: p.label
#: src/routes/SystemPrompts.tsx:61
msgid "Unarchive prompt \"{0}\"?"
msgstr "Unarchive prompt \"{0}\"?"

#. placeholder {0}: v.version
#. placeholder {1}: v.channel
#: src/routes/Releases.tsx:70
msgid "Unarchive version {0} on {1}?"
msgstr "Unarchive version {0} on {1}?"

#: src/components/RequestPricing.tsx:16
msgid "Unavailable"
msgstr "Unavailable"

#: src/routes/CustomerDetail.tsx:458
msgid "Unpause (paid)"
msgstr "Unpause (paid)"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:368
msgid "Unpause {0}? Access resumes at the next agent request."
msgstr "Unpause {0}? Access resumes at the next agent request."

#: src/routes/ConversationDetail.tsx:191
#: src/routes/Conversations.tsx:474
msgid "Updated"
msgstr "Updated"

#: src/routes/SystemPrompts.tsx:129
msgid "Updated at"
msgstr "Updated at"

#: src/components/Layout.tsx:173
#: src/routes/Customers.tsx:271
#: src/routes/Usage.tsx:119
msgid "Usage"
msgstr "Usage"

#: src/routes/Usage.tsx:58
msgid "Usage & cost"
msgstr "Usage & cost"

#. placeholder {0}: usage.month
#: src/routes/CustomerDetail.tsx:622
#: src/routes/CustomerDetail.tsx:1341
msgid "Usage this month ({0})"
msgstr "Usage this month ({0})"

#: src/routes/NewConfig.tsx:383
msgid "Use the id generated from the display name"
msgstr "Use the id generated from the display name"

#: src/routes/Plans.tsx:318
msgid "Used only to name a new conversation, once per conversation. Pick the cheapest active model — the task needs no tools and no reasoning."
msgstr "Used only to name a new conversation, once per conversation. Pick the cheapest active model — the task needs no tools and no reasoning."

#: src/routes/Conversations.tsx:365
msgid "User feedback"
msgstr "User feedback"

#: src/features-catalog.ts:150
msgid "User Portal"
msgstr "User Portal"

#: src/routes/NewConfig.tsx:495
msgid "Username"
msgstr "Username"

#: src/components/Layout.tsx:198
msgid "Users"
msgstr "Users"

#: src/routes/AuditLog.tsx:80
#: src/routes/LicenseSwaps.tsx:69
#: src/routes/LicenseSwaps.tsx:80
msgid "uuid"
msgstr "uuid"

#: src/routes/Releases.tsx:144
msgid "Version"
msgstr "Version"

#: src/routes/Releases.tsx:288
msgid "Version (semver, e.g. 0.2.0)"
msgstr "Version (semver, e.g. 0.2.0)"

#: src/routes/Monitoring.tsx:243
msgid "View all →"
msgstr "View all →"

#: src/routes/Usage.tsx:262
msgid "View conversation"
msgstr "View conversation"

#: src/routes/CustomerDetail.tsx:573
msgid "View features"
msgstr "View features"

#: src/components/FeatureSelector.tsx:141
#: src/features-catalog.ts:163
msgid "Web API post"
msgstr "Web API post"

#: src/components/FeatureSelector.tsx:139
#: src/features-catalog.ts:161
msgid "Web API read"
msgstr "Web API read"

#: src/components/FeatureSelector.tsx:140
#: src/features-catalog.ts:162
msgid "Web API write"
msgstr "Web API write"

#: src/routes/ConversationDetail.tsx:394
msgid "What happened, and what did we tell the customer?"
msgstr "What happened, and what did we tell the customer?"

#: src/routes/Releases.tsx:347
msgid "What's new in this release"
msgstr "What's new in this release"

#: src/routes/Errors.tsx:382
#: src/routes/Monitoring.tsx:200
#: src/routes/Monitoring.tsx:252
msgid "When"
msgstr "When"

#: src/routes/AuditLog.tsx:101
#: src/routes/LicenseSwaps.tsx:129
msgid "When (UTC)"
msgstr "When (UTC)"

#: src/routes/Conversations.tsx:66
msgid "With failures"
msgstr "With failures"

#: src/credit-reason-labels.ts:13
#: src/feedback-labels.ts:13
msgid "Wrong answer"
msgstr "Wrong answer"

#: src/routes/Releases.tsx:95
msgid "yes"
msgstr "yes"
